import React from 'react'
import PropTypes from 'prop-types'
import LazyLoad from 'react-lazyload'
import { getLazyLoadScrollContainer } from '../../helper/scroll'
import { isPrerender } from '../../styles/media'

const LazyLoadIfNotPrerender = ({ children, disabled, height, offset }) => {
	if (isPrerender() || disabled) {
		return children
	}

	return (
		<LazyLoad height={height} offset={offset} scrollContainer={getLazyLoadScrollContainer()}>
			{children}
		</LazyLoad>
	)
}

LazyLoadIfNotPrerender.propTypes = {
	children: PropTypes.any.isRequired,
	disabled: PropTypes.bool,
	height: PropTypes.number,
	offset: PropTypes.number
}

LazyLoadIfNotPrerender.defaultProps = {
	disabled: false,
	height: 30,
	offset: 100
}

export default LazyLoadIfNotPrerender
